"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TendermintQueryClient = void 0;
var axios_1 = __importDefault(require("axios"));
var TendermintQueryClient = /** @class */ (function () {
    function TendermintQueryClient(baseUrl) {
        this.axios = axios_1.default.create({
            baseURL: baseUrl,
            headers: {
                Accept: "application/json",
            },
            timeout: 15000,
        });
    }
    TendermintQueryClient.prototype.queryEstimateGas = function (hexTx) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result, data, jsonString, jsonData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/abci_query?path=\"app/simulate\"";
                        return [4 /*yield*/, this.axios.get(path, { params: { data: hexTx } })];
                    case 1:
                        result = _a.sent();
                        data = result.data.result.response.value;
                        if (result.data.result.response.code != 0) {
                            throw result.data.result.response.log;
                        }
                        jsonString = Buffer.from(data, "base64").toString("utf8");
                        jsonData = JSON.parse(jsonString);
                        return [2 /*return*/, Number.parseInt(jsonData.gas_info.gas_used)];
                }
            });
        });
    };
    TendermintQueryClient.prototype.queryChainSyncInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/status";
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.result.sync_info];
                }
            });
        });
    };
    TendermintQueryClient.prototype.queryTransactionHash = function (txHash) {
        return __awaiter(this, void 0, void 0, function () {
            var path, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/tx?hash=" + txHash;
                        return [4 /*yield*/, this.axios.get(path)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.result];
                }
            });
        });
    };
    return TendermintQueryClient;
}());
exports.TendermintQueryClient = TendermintQueryClient;
// https://imperium-lcd.firmachain.org:26657/abci_query?path=%22app/simulate%22&data=0x0a9b010a8d010a1c2f636f736d6f732e62616e6b2e763162657461312e4d736753656e64126d0a2c6669726d6131747271796c65396d326e7679616663326e323566726b70776564323530347936617667667a72122c6669726d6131306e65336e77346b63666a36766a7a38346c326d33676a38767961637a66686d6135666636391a0f0a0475666374120731303030303030120974657374206d656d6f12670a510a460a1f2f636f736d6f732e63727970746f2e736563703235366b312e5075624b657912230a21027b57273b1d23a87862c6a47f214d77b6144b552498c2dff9e9368551b4e08a8c12040a02080118e60412120a0c0a047566637412043230303010c09a0c1a40ce1072ff09660c80595b7ff2fec36062ebcf8fde88947f1fa3f6cb5ff808edba04fcf584f81ce52e5ec9be6724759fb58a411a17ed2816210f4df5b811117e4c 
// 6669726d613177613375346b6e773734723539387175767a7964766361343271736d6b366a727667716e3779
// curl 'http://0.0.0.0:26657/abci_query?path="/store/acc/key"&data=0x6669726d6131383934767470336461756d737a70397a36306564657074736a786a6667656d656a73646b3277'
// curl 'http://0.0.0.0:26657/abci_query?path="/account/tbnb1hn8ym9xht925jkncjpf7lhjnax6z8nv2mu9wy3'
